import { ReactNode, HTMLAttributes } from 'react'
type TextLinkProps = HTMLAttributes<HTMLAnchorElement> & {
  children?: ReactNode
}
export const TextLink = ({ children, ...props }: TextLinkProps) => {
  return (
    <a
      {...props}
      className="border-b-[0.08em] border-solid border-[currentColor] text-inherit transition-all duration-200 ease-in hover:border-gray-500 hover:text-gray-500"
    >
      {children}
    </a>
  )
}
